export default "/_next/static/src/lib/assets/rive/ae2d0aab27f4c65a551ae8c18b7dfca4.riv";